import { createAction, createListenerMiddleware } from '@reduxjs/toolkit'
import { sessionUpdated } from '../../App/app';

import { RootState } from '../store';
import { customSessionUpdated } from '../../pages/CustomSSO/custom-sso';

export const initStorage = createAction( 'app/initStorage' );

import { hgsKeyBackendUri } from '../../uris';


const listenerMiddlewarePostAuth = createListenerMiddleware()

// this middleware is used to update the registration status of user after succuessful log in

listenerMiddlewarePostAuth.startListening( {
  actionCreator: customSessionUpdated,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;
    await updateRegistrationStatus( state );

  }
} )

listenerMiddlewarePostAuth.startListening( {
  actionCreator: sessionUpdated,
  effect: async( action, listenerApi ) => {

    const state = listenerApi.getState() as RootState;
    await updateRegistrationStatus( state );

  }

} )

const updateRegistrationStatus = async (state: RootState) => {


  const isRegisteredFlag = state.app.attributes['custom:is_registered'];
  const switchToEmailFlowFlag = state.app.attributes['custom:switch_to_email_flow'];

  if( ! (isRegisteredFlag === 'true' && switchToEmailFlowFlag === 'false') ) {

    const { idToken } = state.app.session;
    try {

      const response = await fetch(`${hgsKeyBackendUri}/registration/complete`, {
        method: 'POST',
        headers: {
          "Authorization": idToken
        }
      })

      if ( !response.ok ) {

       throw new Error( 'Failed to update registration status' );

      }
    } catch (err) {

      console.log(err);

    }
  }

}

export default listenerMiddlewarePostAuth;
